module.exports = __webpack_public_path__ + "static/img/cooperation.6a80777.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cooperation/cooperation.jpg
// module id = WNBd
// module chunks = 11